'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { useState } from 'react'

type Props = {
  defaultValue?: string
  paramKey?: string
  onSearch?: () => void
}

export const useSearch = ({
  defaultValue = '',
  paramKey = 'searchValue',
  onSearch,
}: Props) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const [value, setValue] = useState(defaultValue)

  const handleInputChange = (newValue: string) => {
    setValue(newValue)
  }

  const updateQueryAndNavigate = (searchValue: string) => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')
    params.delete('page')

    if (searchValue) {
      params.set(paramKey, searchValue)
    } else {
      params.delete(paramKey)
    }

    router.push(`?${params.toString()}`)
    onSearch?.()
  }

  const handleReset = () => {
    updateQueryAndNavigate('')
  }

  const handleSearch = () => {
    updateQueryAndNavigate(value)
  }

  return {
    value,
    handleInputChange,
    handleSearch,
    handleReset,
  }
}
